import { useAutocompleteSource } from '@eas/common-web';
import { DictCountryAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useCountries() {
  return useAutocompleteSource<DictCountryAutocomplete>({
    url: `${EvidenceApiUrl.DICT_COUNTRIES}/autocomplete`,
  });
}
